import React from 'react';
import CommentCard from './ComentCard.jsx';
import img1 from '../../img/schoolDate1.png'
import img2 from '../../img/schoolDate2.png'
import img3 from '../../img/schoolDate3.png'
import styled from 'styled-components';
import { device } from '../MainContents/Style/StyleDevice'

const Heading = styled.h2`
    margin-bottom: 30px;
    padding: 15px;
    font-size: 24px;
    font-size: 1.5rem;
    background-color:#009d80;
    color: #fff;
    border-radius: 7px;
    margin-top: 50px;
`;

const MarginWid = styled.div`
    width: 80%;
    margin:0 auto;
    margin-bottom: 30px;
    border:2px solid #f5f5f5;
    border-radius: 3px;
    @media ${device.laptop}{
        width:100%;
     }
`;

const Messeage = styled.h4`color:rgb(0, 173, 128);`;
const Comment = () => {
    return (
        <>





            <p className="text">今年度の入試で注目されたのは「岡豊（普通）」だった！</p>

            <p className="text">統一模試3回目から志望者数がド～ンと増える<span style={{ color: 'rgb(0, 173, 128)' }}>「怪しい動き」</span>をしていた事もあり、倍率は5番手だが不合格者数が凄まじい結果に　(；・∀・)</p>

            <p className="text">また、近年は高知農業も注目されている。学校全体で6学科240名募集に対し、B日程も含めると212名の合格者である。</p>

            <p className="text">普通科を志望するのも良いと思うが、少し専門性の高い高校にも視野を広げ、「自分の進むべき道」と照らし合わせながら選択するのも一つの方法ではないかと思う。</p>

            <p className="text">受験生の皆さんは、年間を通じて自分の志望校の動向は常に把握しておいてください。</p>
            <p className="text">ライバルが増加し倍率が上がっても「合格者」になるためは、本番入試までに実力をつけるしかない。
                残された時間を悔いのないように過ごして欲しい。
            </p>


            <Heading>進路選択のポイントは</Heading>
            <ul>
                <li>①その学校・学科は、どんな内容をどのように学習するのか？</li>
                <li>②その学校を卒業したらどんな学校に進学したり、どんな資格をとったり、どんな企業に就職しているのか？高校で行われる学校説明会、入学案内パンフレット、高校のホームページや部活の先輩の話などまで参考にして、 まず、自分の将来から考えてみよう。 そして、合格するには、進学への意欲をしっかりと持ち、早い時期から勉強すればいいんです。 また、高校以降も困らない学力をつけることができるのも今だけだ。</li>
            </ul>
            <Heading>来年度の公立高校入試に向けては</Heading>
            <ul>
                <li>①人気のある学校・学科はやはり難しい。志望動向の変化は高知市周辺高校にも影響する。</li>
                <li>②入試問題が、思考力を問う問題、記述による解答を求める問題へとレベルアップしている。</li>
            </ul>
            <p className="text">
                受験生に人気のある学校・学科は、来春の入試も厳しいことは間違いないが、 郡部の志望者数の少ない学校・学科を受験するから、「自分にはあまり関係ない」と思う受験生もいるかもしれない。 しかし、入学志望者数の動向と定員との関係は大きく変化しないので、第一志望が厳しいと判断されると、 第二・第三志望へと受験校を変更し、地元の人気の高い順に難しくなる。
                一日も早く高校入試の現実を知り、意識を改め受験勉強に取り組み、志望する高校への合格をつかんでもらいたい。
            </p>

            <div className='mt-5 text-center'>
                <Messeage>高校入試は自分の実力を問われる真剣勝負です！</Messeage>
            </div>
            <Heading>「参考資料」　過去の統一模試志望者動向</Heading>
            <p>※受験者動向の大きく変化した3校（高知農業（食ビ）（丸の内（普通）（岡豊（普通）の統一模試志願者数の推移を表した。
                本番入試では難しくなると予想されていた。
            </p>

            <CommentCard
                title={'【高知農業(食ビ)】　（定員：40名）'}
                text={'定員は40名に対し、50名が受験した。'}
                imgResult={img1}
            />
            <CommentCard
                title={'【丸の内(普通)】　（定員：140名）'}
                text={'流石2023年度の倍率王者（1位）であり、人気校140名に対し、176名が受験した。'}
                imgResult={img2}
            />
            <CommentCard
                title={'【岡豊(普通)】　（定員：240名）'}
                text={'㊤でも触れましたが、回数を追うごとに「え？なんで岡豊　(´･ω･)?」が第一印象でした。模試志望者最高値は230付近でしたが、本番は293名が受験。他校でもある事ですが、模試の志望者数を本番は上回ってきます。「A判定が出たので・・・」は危険ですよ！'}
                imgResult={img3}
            />

        </>
    );
}

export default Comment;